import { useEffect, useMemo, useState } from "react";
import { useIsMobile } from "@/hooks/useIsMobile";
import type { PartyRoleFilter, PartyViewMode } from "../parties.constants";

export function usePartiesPageState() {
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState<PartyRoleFilter>("");
  const [viewMode, setViewMode] = useState<PartyViewMode>("table");
  const isMobile = useIsMobile();

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedSearch(search), 250);
    return () => clearTimeout(timeout);
  }, [search]);

  useEffect(() => {
    if (isMobile) setViewMode("grid");
  }, [isMobile]);

  const filters = useMemo(
    () => ({ search: debouncedSearch, roleFilter }),
    [debouncedSearch, roleFilter],
  );

  return {
    search,
    setSearch,
    roleFilter,
    setRoleFilter,
    viewMode,
    setViewMode,
    filters,
  };
}
